module.exports = __webpack_public_path__ + "static/media/bg11.e643a6cf.jpg";